import { Button, Form } from "react-bootstrap";
import DepartementSelect from "../../components/DepartementSelect";
import TimeZoneSelect from "../../components/TimeZoneSelect";
import { useForm, FormProvider, Controller } from "react-hook-form";
import InputWorkingDaysTime from "../../components/InputWorkingDaysTime";
import { inviteUserApi } from "../../api/inviteUserApi";
import Swal from "sweetalert2";
import { useContext, useEffect, useState } from "react";
import BackButton from "../../components/button/BackButton";
import { NumericFormat } from "react-number-format";
import InfoIcon from "../../components/utilities/InfoIcon";
import { Typography } from "../../components/utilities/Typhograpy";
import GlobalContext from "../../context/GlobalContext";
import ModalImportSchedule from "../../components/modal/ModalImportSchedule";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import SelectPayrollTemplate from "../../components/select/SelectPayrollTemplate";
import SelectPersonnel from "../../components/select/SelectPersonnel";
import { fetchSchedules } from "../../api/ScheduleApi";

import { tr } from "../../i18n";
const UserInvitation = () => {
  const methods = useForm();
  const { user } = useContext(GlobalContext);
  const {
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = methods;
  const [alert, setAlert] = useState({
    isShow: false,
    variant: "",
    message: "",
  });

  const [openModal, setOpenModal] = useState(false);
  const [importedSchedule, setImportedSchedule] = useState(null);
  const [defaultTimeZone, setDefaultTimeZone] = useState(null);

  // Isi awal jadwal & zona waktu dari template jadwal default organisasi (template paling awal,
  // dibuat saat registrasi) supaya karyawan baru langsung bisa absen. Admin tetap bisa mengubahnya.
  useEffect(() => {
    const companyId = user?.workspace?.company_id;
    if (!companyId) return;

    let active = true;
    fetchSchedules({ companyId, page: 1, perPage: 100 })
      .then((response) => {
        const templates = response?.data || [];
        const defaultTemplate = templates[templates.length - 1];
        if (!active || !defaultTemplate) return;

        if (defaultTemplate.schedule?.length) {
          setImportedSchedule({ schedules: defaultTemplate.schedule });
        }
        if (defaultTemplate.time_zone) {
          setDefaultTimeZone({ id: defaultTemplate.time_zone, text: defaultTemplate.time_zone });
          methods.setValue("timeZone", defaultTemplate.time_zone);
        }
      })
      .catch(() => {});

    return () => {
      active = false;
    };
  }, [user?.workspace?.company_id]);

  const handleImport = (selectedSchedule) => {
    setImportedSchedule({ schedules: selectedSchedule });
    setOpenModal(false);
  };

  const handleCloseAlert = () => {
    setAlert({ isShow: false, variant: "", message: "" });
  };

  return (
    <div className="box-shadow">
      {alert.isShow ? (
        <div
          className={`alert alert-${alert.variant} alert-dismissible fade ${
            alert.isShow ? "show" : "hide"
          }`}
          role="alert"
        >
          {alert.message}
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="alert"
            aria-label={tr("common:actions.close")}
            onClick={handleCloseAlert}
          ></button>
        </div>
      ) : (
        ""
      )}

      <FormProvider {...methods}>
        <Form
          onSubmit={handleSubmit(async (data) => {
            const dataUser = {
              company_id: user.workspace.company_id,
              first_name: data.first_name,
              last_name: data.last_name,
              email: data.email,
              internalId: data.internalId,
              internalEmail: data.internalEmail,
              join_date: data.join_date || null,
              payroll_template_id: data.payroll_template_id,
              sallary: data.sallary,
              department: data.department,
              timeZone: data.timeZone,
              schedule: data.schedule,
              supervisor: data.supervisor,
            };

            const response = await inviteUserApi(dataUser);

            if (response.status == 200) {
              reset();
              handleCloseAlert();

              let reloadDone = false;

              Swal.fire({
                title: tr("shared:success"),
                text: response.message,
                icon: "success",
                confirmButtonColor: "#0d6ef0",
                iconColor: "#007DFF",
                customClass: {
                  confirmButton: "swal-confirm-button",
                },
              }).then(() => {
                if (!reloadDone) {
                  reloadDone = true;
                  window.location.reload();
                }
              });

              // // Fallback: reload paksa setelah 5 detik kalau user belum klik apa-apa
              // setTimeout(() => {
              //     if (!reloadDone) {
              //         reloadDone = true;
              //         window.location.reload();
              //     }
              // }, 5000);
            } else {
              const errorMessage = response.message;
              const errorData = response.errors;

              if (errorData) {
                Object.keys(errorData).forEach((key) => {
                  setError(key, { type: "manual", message: errorData[key] });
                });
              }

              setAlert({
                isShow: true,
                variant: "danger",
                message: errorMessage,
              });
            }
          })}
        >
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label">
              <Typography variant="form">
                {tr("shared:email")}{" "}
                <InfoIcon info="This is the employee's personal email. Use this email to invite them to your organization." />{" "}
                <span className="text-danger">*</span>
              </Typography>
            </label>
            <div class="col-sm-10">
              <input
                {...methods.register("email", {
                  required: tr("users:this_email_is_required"),
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: tr("users:invalid_email_address"),
                  },
                })}
                type="text"
                class={`form-control ${errors.email ? "is-invalid" : ""} `}
                placeholder={tr("users:user_email")}
              ></input>
              {errors.email ? (
                <small className="invalid-feedback">
                  {errors.email.message}
                </small>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="form-group row mb-3">
                <label class="col-sm-4 col-form-label">
                  <Typography variant="form">
                    {tr("users:first_name")}{" "} <span className="text-danger">*</span>
                  </Typography>
                </label>
                <div class="col-sm-8">
                  <input
                    {...methods.register("first_name", {
                      required: tr("users:first_name_is_required"),
                    })}
                    type="text"
                    class={`form-control ${
                      errors.first_name ? "is-invalid" : ""
                    } `}
                    placeholder={tr("users:first_name")}
                  ></input>
                  {errors.first_name ? (
                    <small className="invalid-feedback">
                      {errors.first_name.message}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group row mb-3">
                <label class="col-sm-4 col-form-label">
                  <Typography variant="form">{tr("users:last_name")}</Typography>
                </label>
                <div class="col-sm-8">
                  <input
                    {...methods.register("last_name")}
                    type="text"
                    class="form-control"
                    placeholder={tr("users:last_name")}
                  ></input>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label">
              <Typography variant="form">
                {tr("shared:internal_id")}{" "}
                <InfoIcon info="The Internal ID refers to your organization's internal employee identifier outside of Sewoork. This field is optional." />
              </Typography>
            </label>
            <div class="col-sm-10">
              <input
                {...methods.register("internalId")}
                type="text"
                class="form-control"
                placeholder={tr("users:user_internal_id")}
              ></input>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label">
              <Typography variant="form">
                {tr("users:internal_email_2")}{" "}
                <InfoIcon info="Internal email refers to the email address provided by the organization for each employee. If left blank, the employee's personal email will be used instead." />
              </Typography>
            </label>
            <div class="col-sm-10">
              <input
                {...methods.register("internalEmail", {
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: tr("users:invalid_email_address"),
                  },
                })}
                type="text"
                class={`form-control ${
                  errors.internalEmail ? "is-invalid" : ""
                } `}
                placeholder={tr("users:user_internal_email")}
              ></input>
              {errors.internalEmail ? (
                <small className="invalid-feedback">
                  {errors.internalEmail.message}
                </small>
              ) : (
                ""
              )}
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label">
              <Typography variant="form">
                {tr("shared:join_date")}{" "}
                <InfoIcon info="The date the employee officially joined or will join the organization." />
              </Typography>
            </label>
            <div class="col-sm-10">
              <input
                {...methods.register("join_date")}
                type="date"
                class="form-control"
              ></input>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label">
              <Typography variant="form">{tr("users:supervisor")}</Typography>
            </label>
            <div class="col-sm-10">
              <SelectPersonnel
                name="supervisor"
                label={tr("users:select_supervisor")}
                placeholder={tr("users:choose_supervisor")}
                className={`${errors.timeZone ? "is-invalid" : ""}`}
              ></SelectPersonnel>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label">
              <Typography variant="form">
                {tr("shared:payroll_schema")}
              </Typography>
            </label>
            <div class="col-sm-10">
              <SelectPayrollTemplate
                name="payroll_template_id"
                label={tr("users:select_template_schema")}
                placeholder={tr("users:choose_template_schema")}
                className={`${errors.payroll_template_id ? "is-invalid" : ""}`}
              ></SelectPayrollTemplate>
              <small className="text-muted">{tr("users:payroll_schema_optional_hint")}</small>
              {errors.payroll_template_id && (
                <small className="text-danger d-block">{errors.payroll_template_id.message}</small>
              )}
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label">
              <Typography variant="form">
                {tr("users:sallary")}{" "}
                <InfoIcon
                  size="sm"
                  info="Salary follows your organization's currency in the settings. "
                />{" "}
                <span className="text-danger">*</span>
              </Typography>
            </label>
            <div class="col-sm-10">
              <div
                style={{ position: "relative" }}
                className={`${errors.sallary ? "is-invalid" : ""}`}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    color: "#6c757d",
                    pointerEvents: "none",
                  }}
                >
                  Rp
                </span>

                <Controller
                  name="sallary"
                  control={methods.control}
                  rules={{ required: tr("users:the_salary_is_required") }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <NumericFormat
                      value={value}
                      thousandSeparator="."
                      decimalSeparator=","
                      allowNegative={false}
                      onValueChange={(values) => {
                        onChange(values.value);
                      }}
                      className={`form-control ${error ? "is-invalid" : ""}`}
                      placeholder={tr("users:sallary")}
                      style={{ paddingLeft: "35px" }} // Supaya gak nabrak "Rp"
                    />
                  )}
                />
              </div>
              {errors.sallary ? (
                <small className="invalid-feedback">
                  {errors.sallary.message}
                </small>
              ) : (
                ""
              )}
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label">
              <Typography variant="form">{tr("shared:department")}</Typography>
            </label>
            <div class="col-sm-10">
              <DepartementSelect
                className={`${errors.department ? "is-invalid" : ""}`}
              ></DepartementSelect>
              {errors.department ? (
                <small className="invalid-feedback">
                  {errors.department.message}
                </small>
              ) : (
                ""
              )}
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="col-sm-2 col-form-label" style={{ paddingRight: 0 }}>
              <Typography variant="form">
                {tr("shared:time_zone")}{" "} <span className="text-danger">*</span>
              </Typography>
            </label>
            <div className="col-sm-4">
              <TimeZoneSelect
                defaultValue={defaultTimeZone}
                rules={{ required: tr("shared:time_zone_is_required") }}
                className={`${errors.timeZone ? "is-invalid" : ""}`}
              ></TimeZoneSelect>
              {errors.timeZone ? (
                <small className="invalid-feedback">
                  {errors.timeZone.message}
                </small>
              ) : (
                ""
              )}
            </div>
          </div>
          <div class="form-group row mb-3">
            <div className="col-sm-2">
              <label className="col-form-label" style={{ paddingRight: 0 }}>
                <Typography variant="form">
                  {tr("shared:working_days")}{" "} <span className="text-danger">*</span>
                </Typography>
              </label>

              <Button
                variant="outline-primary"
                className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm mt-2 mb-2"
                onClick={() => setOpenModal(true)}
              >
                <FontAwesomeIcon icon={faUpload} />
                {tr("common:breadcrumb.import")}
              </Button>

              {errors.schedule && (
                <small className="text-danger">{errors.schedule.message}</small>
              )}
            </div>

            <div class="col-sm-10">
              <InputWorkingDaysTime
                defaultValue={importedSchedule}
                isClear={true}
              />
            </div>
          </div>
          <div class="form-group row mb-3">
            <div class="col-sm-12 d-flex justify-content-between">
              <BackButton />
              <Button
                type="submit"
                className={`btn btn-primary btn-md ${
                  Object.keys(errors).length > 0 ? "disabled" : ""
                }`}
              >
                {tr("users:send_invitation")}
              </Button>
            </div>
          </div>
        </Form>
      </FormProvider>
      <ModalImportSchedule
        show={openModal}
        onClose={() => setOpenModal(false)}
        onSelect={handleImport}
      />
    </div>
  );
};

export default UserInvitation;
